import React from "react";
import styles from '../styles/bettingRecords.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import Icon from "@/wmCompoments/Icon";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";



export interface BettingRecordsProps {
  list: any[]
}

const BettingRecords = ({ list }: BettingRecordsProps) => {
  const { t } = useTranslation('record')
  const handleCopy = (v) => {
    if(ut.copyBoard(v)) {
        Toast.show(t('copySuccess'))
    }
  }

  const formatOddsType = (oddsType?: string) => {
    if (oddsType === "HK") return t('hongKongOdds');
    return t('europeanOdds');
  }

  const getNetAmountDisplay = (netAmount: number, flag: number) => {
    if (flag === 0) return t('unsettled');
    if (flag === 2) return t('cancel');
    if (flag === 3) return t('invalid');
    if (flag === 4) return t('reset');
    if (netAmount > 0) return `+${netAmount}`;
    return `${netAmount}`;
  }

  const getBetResult = (flag: number) => {
    if (flag === 0 || flag === 1 || flag === 4) return "投注成功";
    if (flag === 2 || flag === 3) return t('betFailed');
    return "--";
  }

  const formatVenueName = (venueName: string, playInfo: any[]) => {
    if (!playInfo || playInfo.length === 0) return venueName;
    return playInfo.length === 1 ? `${t('singleBet')}-${venueName}` : `${t('multipleBet')}-${venueName}`;
  }


  return(
    <div className={styles.bettingRecords}>
      {list.map((v,index)=>{
        // 净输赢金额
        const netAmountText = getNetAmountDisplay(parseFloat(v.netAmount), v.flag);
        // 投注状态
        const resultText = getBetResult(v.flag);
        // 场馆名称
        const venueName = formatVenueName(v.venueName, v.playInfo);
        // 盘口类型
        const oddsType = formatOddsType(v.oddsType);

        return(
          <div className={styles.items} key={index}>
            <div className={styles.title}>
              <div className={styles.billNo}>
                <span>{t('orderNumber')}{v.venueBillNo}</span>
                <Icon name={'icon-games-copy'} className={styles.copy} onClick={()=>handleCopy(v.venueBillNo)} />
              </div>
              <SpriteContainer name='icon_wallet_balance' module={'wallet'} />
            </div>

            <div className={styles.content}>
              <div>
                <div>{t('venueBetType')}</div>
                <div>{venueName}</div>
              </div>

              <div>
                <div>{t('joinGame')}</div>
                <div>{v.gameName}({resultText})</div>
              </div>

              {v.gameType === 2 && v.gamePlayInfo && (
                <div>
                  <div>{t('betTypeInfo')}</div>
                  <div>{v.gamePlayInfo}</div>
                </div>
              )}

              {Array.isArray(v.playInfo) && v.playInfo.map((play, idx) => (
                <div key={idx}>
                  <div>{t('leagueName')}</div>
                  <div>{play.leagueName}</div>
                </div>
              ))}
              {Array.isArray(v.playInfo) && v.playInfo.map((play, idx) => (
                <div key={idx}>
                  <div>{t('matchTime')}</div>
                  <div>{play.startingTime}</div>
                </div>
              ))}
              {Array.isArray(v.playInfo) && v.playInfo.map((play, idx) => (
                <div key={idx}>
                  <div>{t('teams')}</div>
                  <div>{play.teams}</div>
                </div>
              ))}
              {Array.isArray(v.playInfo) && v.playInfo.map((play, idx) => (
                <div key={idx}>
                  <div>{t('betType')}</div>
                  <div>{play.playType} @ {play.odds}</div>
                </div>
              ))}

              <div>
                <div>{t('betAmount')}</div>
                <div>{v.betAmount}</div>
              </div>

              <div>
                <div>{t('winLossAmount')}</div>
                <div>{netAmountText}</div>
              </div>

              <div>
                <div>{t('turnover')}</div>
                <div>{v.betAmount}</div>
              </div>

              <div>
                <div>{t('betTime')}</div>
                <div>{v.betTime}{oddsType}</div>
              </div>

            </div>

          </div>
        )
      })}
    </div>
  )
}

export default BettingRecords